import React from "react";

interface Props {
    disabled: boolean;
}

const ChildCareFields = ({ disabled: _disabled }: Props) => {

    return <></>;
};

export default ChildCareFields;
